import { useState } from "react";
import API from "../axios";
import { useNavigate } from "react-router-dom";
import styles from "./Login.module.css";

const Login = () => {
    const navigate = useNavigate();

    const [username, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleLogin = async function () {
        setLoading(true);

        try {
            const result = await API.login(username, password);            
            if (result && result.status) {
                if (!result.is_customer_shipping) {
                    localStorage.setItem("user_token", result.token);
                    localStorage.setItem("user_email", username);
                    navigate("/", { replace: true });
                } else {
                    localStorage.setItem("customer_token", result.token);
                    navigate("/cs-shipping", { replace: true });
                }
            } else {
                setError("Invalid username or password.");
                setLoading(false);
                return;
            }
        } catch (error) {
            setError("Login failed. Please try again.");
        }

        setLoading(false);
    };

    return (
        <div
            className={`${styles.mainContainer}`}
            style={{ paddingTop: 100, height: "100%" }}
        >
            <div style={{ maxWidth: 500, margin: "0 auto" }}>
                <div className="card" style={{ marginTop: 130 }}>
                    <div className="card-body">
                        <div className="d-flex flex-column align-items-center my-3">
                            <img src="/icon.png" style={{ width: 100 }} />
                            <h3 className="mt-3 text-primary">Login</h3>
                        </div>
                        <div>
                            <div className="mb-3">
                                <label
                                    htmlFor="username"
                                    className="form-label"
                                >
                                    Username
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="username"
                                    value={username}
                                    onChange={(e: any) =>
                                        setUserName(e.target.value)
                                    }
                                />
                            </div>
                            <div className="mb-3">
                                <label
                                    htmlFor="password"
                                    className="form-label"
                                >
                                    Password
                                </label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="password"
                                    value={password}
                                    onChange={(e) =>
                                        setPassword(e.target.value)
                                    }
                                />
                            </div>
                            <button
                                type="submit"
                                className="btn btn-primary btn-block mt-4"
                                style={{ width: "100%" }}
                                disabled={loading}
                                onClick={handleLogin}
                            >
                                {loading ? "Loading..." : "Login"}
                            </button>
                            {error && (
                                <div
                                    className="alert alert-danger d-flex align-items-center mt-3"
                                    role="alert"
                                >
                                    <i className="bi bi-info"></i>
                                    <div>{error}</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
